import regex from './regex'

export default regex(/[A-Z]{1}/, 'At least 1 uppercase letter')
